// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

class Globals {
  options: string[] = [];
}

export const globals = new Globals();
